import Handlebars from "handlebars";
import { numberToCurrency } from "./number_utils";
import { formattedDate } from "./date_utils";

export const registerNumberToCurrencyHelper = () => {
  Handlebars.registerHelper("number_to_currency", function (amount, options) {
    return numberToCurrency(amount, { currency: options.hash.currency });
  });
};

export const registerFormattedDateHelper = () => {
  Handlebars.registerHelper("formatted_date", function (date) {
    return formattedDate(date);
  });
};
